import { ILabelPrintScenarioDTO, ILabelPrintScenarioItemViewDTO, ILabelPrintScenarioViewDTO } from "../../coreapi-dto/dirs/labelPrintScenario";
import { ContentType } from "../../fetchApiDistributor/contentTypes";
import { CoreApiResponse, IRequestEventHandler } from "../common";
import { BaseDirRequest } from "./baseDirRequest";


interface ILabelPrintScenarioCreate extends ILabelPrintScenarioDTO {
}
interface ILabelPrintScenarioUpdate extends ILabelPrintScenarioDTO {
}

export class LabelPrintScenarioRequest extends BaseDirRequest<ILabelPrintScenarioViewDTO, ILabelPrintScenarioDTO> {

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "LabelPrintScenario", token, eventHandler)
    }

    create(body: ILabelPrintScenarioCreate, callback: (e: CoreApiResponse<string>) => void) {
        super.create(body, callback)
    }

    update(idGlobal: string, body: ILabelPrintScenarioUpdate, callback: (e: CoreApiResponse<null>) => void) {
        super.update(idGlobal, body, callback)
    }

    getItemsView(idGlobal: string, body: IViewBody, callback: (e: CoreApiResponse<IViewWrapper<ILabelPrintScenarioItemViewDTO>>) => void) {
        this.post<IViewWrapper<ILabelPrintScenarioItemViewDTO>>(`${this._baseUrl}/${this._routePrefix}/${idGlobal}/Items`, body,
            this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
                if (this._eventHandler) {
                    if (e.respType === "isFailed") {
                        this._eventHandler.onGetResponse(e);
                    } else {
                        callback?.(e);
                    }
                }
            })
    }
}

